import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as TickIcon } from '../../../public/assets/icons/tick.svg';
import { ReactComponent as MinusIcon } from '../../../public/assets/icons/minus.svg';
// export const months = [
//     { value: 'January', label: 'January' },
//     { value: 'February', label: 'February' },
//     { value: 'March', label: 'March' },
//     { value: 'April', label: 'April' },
//     { value: 'May', label: 'May' },
//     { value: 'June', label: 'June' },
//     { value: 'July', label: 'July' },
//     { value: 'August', label: 'August' },
//     { value: 'September', label: 'September' },
//     { value: 'October', label: 'October' },
//     { value: 'November', label: 'November' },
//     { value: 'December', label: 'December' }
// ];
export const months = Array.from({ length: 12 }, (_, index) => ({
    label: new Date(0, index).toLocaleString('en', { month: 'long' }),
    value: (index + 1).toString()
}));
export const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export const year = [
    {
        label: '2024',
        value: '2024'
    },
    {
        label: '2023',
        value: '2023'
    }
];
export const packageBenefits = {
    Basic: [
        { icon: _jsx(TickIcon, {}), text: 'Payment terms of debtor 30+ days', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Access to online portal', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Monthly newsletter', included: true },
        { icon: _jsx(MinusIcon, {}), text: 'Basic CV review', included: false },
        { icon: _jsx(MinusIcon, {}), text: 'Free primary legal advice', included: false },
        { icon: _jsx(MinusIcon, {}), text: 'Reimbursement of VOG & Chamber of Commerce costs', included: false }
    ],
    Advanced: [
        { icon: _jsx(TickIcon, {}), text: 'Payment within 5 days', included: true },
        { icon: _jsx(TickIcon, {}), text: 'All basic benefits', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Job alerts', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Basic CV review', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Free primary legal advice', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Reimbursement of VOG & Chamber of Commerce costs', included: true }
    ],
    Premium: [
        { icon: _jsx(TickIcon, {}), text: 'Payment within 1 day', included: true },
        { icon: _jsx(TickIcon, {}), text: 'All Advanced benefits', included: true },
        { icon: _jsx(TickIcon, {}), text: 'CV Consulting & optimization', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Proactive recruitment for next assignment', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Access to Quty AI bot from qgroup (coming soon)', included: true },
        { icon: _jsx(TickIcon, {}), text: 'Personal recruitment manager', included: true }
    ]
};
export const getColorAndBackground = (status) => {
    switch (status) {
        case 'Unavailable':
            return { color: '#492A2A', background: '#FDBCBC' };
        case 'Rejected':
            return { color: '#492A2A', background: '#FDBCBC' };
        case 'Disapproved':
            return { color: '#492A2A', background: '#FDBCBC' };
        case 'Open':
            return { color: '#49402A', background: '#FDEDBC' };
        case 'Basic user':
            return { color: '#49402A', background: '#FDEDBC' };
        case 'Premium user':
            return { color: '#3E8291', background: '#EAFDFF' };
        case 'Pending':
            return { color: '#3E8291', background: '#EAFDFF' };
        case 'New':
            return { color: '#3E8291', background: '#EAFDFF' };
        case 'Approved':
            return { color: '#316F1D', background: '#E5FEDE' };
        case 'Complete':
            return { color: '#316F1D', background: '#E5FEDE' };
        case 'Pending Approval':
            return { color: '#C27800', background: '#FFF4E1' };
        case 'Approved Placements':
            return { color: '#1D5C84', background: '#D9F3FF' };
        case 'User Details Pending':
            return { color: '#8A3C00', background: '#FFEBD9' };
        case 'User Admin Approval':
            return { color: '#6A1B9A', background: '#F3E5F5' };
        case 'Placement Complete':
            return { color: '#316F1D', background: '#E5FEDE' };
        default:
            return { color: '#316F1D', background: '#E5FEDE' };
    }
};
